import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';
(function() {
	'use strict'; 

	document.addEventListener('DOMContentLoaded', (event) =>{

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', (e) => {
			
			const carousels = document.querySelectorAll('.carousel-brands');
			if( carousels ) {

				// 2. Define the options (optional)
				const options = {
					root: null, // observes intersection relative to the document's viewport
					rootMargin: '0px', // no margin
					threshold: 0.1 // fires the callback when 10% of the element is visible
				};

				// 3. Define the callback function
				/*
				const callback = (entries, observer) => {
					entries.forEach(entry => {
						// entry.isIntersecting is true when the element enters the viewport
						if (entry.isIntersecting) {
							console.log('Element entered the viewport!');
							// Perform your action (e.g., lazy load content, start animation)
							// Optional: Stop observing the element once the action is done
							//observer.unobserve(entry.target); 
						} else {
							console.log('Element exited the viewport.');
						}
					});
				};
				/**/

				
				
				//console.log('Carousels:', carousels, Splide);
				
				//return
				carousels.forEach((element) => {

					// 4. Create the observer and start observing
					//const observer = new IntersectionObserver(callback, options);

					const slides = element.querySelectorAll('.splide__slide');

					let autoStart =  element.getAttribute('data-auto-start');
					let pauseOnHover =  element.getAttribute('data-pause-onhover');
					let showTitle =  element.getAttribute('data-show-titles');
					let perPageAttr =  element.getAttribute('data-per-page');
					let scrollSpeed =  element.getAttribute('data-speed');
					let arrows =  element.getAttribute('data-arrows');
					let lazyload =  element.getAttribute('data-lazyload');
					let pagination =  element.getAttribute('data-pagination');
					let gap =  element.getAttribute('data-gap');

					if( autoStart === 'true' ) {
						autoStart = true;
					} else {
						autoStart = false;
					}

					if( lazyload === 'true' ) {
						lazyload = true;
					} else {
						lazyload = false;
					}

					if( !perPageAttr ) {
						perPageAttr = 5;
					}

					if( !scrollSpeed ) {
						scrollSpeed = .25;
					} else {
						scrollSpeed = parseFloat(scrollSpeed);
					}

					if( arrows === 'true' ) {
						arrows = true;
					} else {
						arrows = false;
					}

					if( pagination === 'true' ) {
						pagination = true;
					} else {
						pagination = false;
					}

					if( pauseOnHover === 'true' ) {
						pauseOnHover = true;
					} else {
						pauseOnHover = false;
					}

					if( !gap ) {
						gap = 8;
					} else {
						gap = parseInt(gap);
					}

					let direction = scrollSpeed;
					if( element.classList.contains('inverse-direction') ){
						direction = scrollSpeed * -1;
					}

					if( !slides || slides.length <= 0 ) {
						console.error('BRANDS CAROUSEL EMPTY');
						return;
					}

					const primarySlider = new Splide( element, {
						//height : '500px',
						type   : 'loop',
						drag   : 'free',
						focus  : 'center',
						loop		: true,
						rewind		: true,
						cover      	: false,
						perPage: parseInt(perPageAttr),
						gap: gap,
						padding:0,
						lazyLoad: lazyload,
						pagination 	: (slides.length > 3) ? arrows : false,
						arrows     	: (slides.length > 3) ? pagination : false,
						autoScroll: {
							speed: direction,
							autoStart: false,
							pauseOnHover: pauseOnHover
						},
						intersection: {
							inView: {
								autoScroll: autoStart
							},
							outView: {
								autoScroll: false
							},
						},
						/**/
						breakpoints: {
							1920: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1440: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1280: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1024: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							768: {
								gap: 8,
								perPage	: 2
							},
							640: {
								gap: 8,
								perPage	: 1
							}
						}
						/**/
					} );

					primarySlider.on( 'ready', function () {
						//console.log('CAROUSEL READY');
						
						/** /
						// 4. Create the observer and start observing
						const observer = new IntersectionObserver((entries, observer) => {
							entries.forEach(entry => {
								// entry.isIntersecting is true when the element enters the viewport
								if (entry.isIntersecting) {
									console.log('Element entered the viewport!');
									// Perform your action (e.g., lazy load content, start animation)
									// Optional: Stop observing the element once the action is done
									//observer.unobserve(entry.target);
									if( autoStart === true ) {
										primarySlider.Components.AutoScroll.play();
									}
								} else {
									console.log('Element exited the viewport.');
									
									primarySlider.Components.AutoScroll.pause();
								}
							});
						}, options);

						if (element) {
							observer.observe(element); //
						}
						/**/
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'visible', function (slide) {
						//console.info('CAROUSEL VISIBLE', slide);

						return;

						const anim8In = gsap.fromTo(
							slide.slide,
							//document.body.querySelectorAll('.carousel-pirates .pirate-item'), 
							{
								//autoAlpha: 0,
								scale: .8,
								translateZ: 0,
							},
							{
								//autoAlpha: 1,
								scale: 1,
								translateZ: 0,
								/** /
								stagger: {
									amount: 0.1,
									from: 'end'
								},
								/**/
								//duration: 4,
								overwrite: false,
								//immediateRender: false,
								//ease: Power0.easeInOut,
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									//console.info('CAROUSEL ANIMATE IN COMPLETE', evt);
								}),
								/** /
								scrollTrigger: {
									trigger: document.body.querySelector('.carousel-pirates  .pirate-item'), // Element that triggers the animation.
									start: 'top bottom-=50%', // Animation starts when element hits bottom of viewport.
									//start: 'clamp(top top)',
									end: 'bottom center+=20%', // Animation ends in the center of the viewport.
									//end: 'clamp(bottom center)',
									scrub: true, // Animation progress tied to scroll position.
									anticipatePin: 1,
									/** /
									markers: {
										startColor: "green", 
										endColor: "red", 
										fontSize: "12px"
									},
									anticipatePin: 1,
									/** /
								},
								/**/
							},
							
						);

						/** /
						const anim8Out = gsap.fromTo(
							document.body.querySelectorAll('.carousel-pirates .pirate-item:not(.is-visible)'), 
							{
								autoAlpha: 1,
								scale: 1,
							},
							{
								autoAlpha: 0,
								scale: .8,
								stagger: {
									amount: 0.1,
									//from: 'start'
								},
								//duration: 4,
								overwrite: false,
								//ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									console.log('CAROUSEL ANIMATE OUT COMPLETE');

									const anim8In = gsap.fromTo(
										document.body.querySelectorAll('.carousel-pirates .pirate-item.is-visible'), 
										{
											autoAlpha: 0,
											scale: .8,
										},
										{
											autoAlpha: 1,
											scale: 1,
											stagger: {
												amount: 0.1,
												//from: 'start'
											},
											//duration: 4,
											overwrite: false,
											//ease: Power0.easeInOut
											//immediateRender: false,
											//ease: Power0.easeInOut
											ease: Power0.easeOut,
											onComplete: ((evt)=>{
												console.log('CAROUSEL ANIMATE IN COMPLETE');
											})
										},
										
									);
								})
							},
							
						);
						/**/

						/** /
						const anim8In = gsap.fromTo(
							document.body.querySelectorAll('.carousel-pirates .pirate-item'), 
							{
								//autoAlpha: 0,
								scale: .8,
								translateZ: 0,
							},
							{
								//autoAlpha: 1,
								scale: 1,
								translateZ: 0,
								stagger: {
									amount: 0.1,
									from: 'end'
								},
								//duration: 4,
								overwrite: false,
								//immediateRender: false,
								//ease: Power0.easeInOut,
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									console.log('CAROUSEL ANIMATE IN COMPLETE');
								}),
								scrollTrigger: {
									trigger: document.body.querySelector('.carousel-pirates'), // Element that triggers the animation.
									start: 'top bottom-=50%', // Animation starts when element hits bottom of viewport.
									//start: 'clamp(top top)',
									//end: 'bottom center+=15%', // Animation ends in the center of the viewport.
									end: 'clamp(bottom center)',
									scrub: true, // Animation progress tied to scroll position.
									anticipatePin: 1,
									/** /
									markers: {
										startColor: "green", 
										endColor: "red", 
										fontSize: "12px"
									},
									anticipatePin: 1,
									/** /
								},
							},
							
						);
						/**/
					} );

					// Fired when any slide gets hidden from the view port.
					primarySlider.on( 'hidden', function (slide) {
						//console.info('CAROUSEL HIDDEN', slide);

						return;

						const anim8Out = gsap.fromTo(
							slide.slide,
							{
								autoAlpha: 1,
								scale: 1,
							},
							{
								autoAlpha: 1,
								scale: .8,
								/** /
								stagger: {
									amount: 0.1,
									//from: 'start'
								},
								/**/
								//duration: 4,
								overwrite: false,
								//ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									//console.info('CAROUSEL ANIMATE OUT COMPLETE', evt);
								})
							},
							
						);

						/** /
						const anim8Out = gsap.fromTo(
							document.body.querySelectorAll('.carousel-pirates .pirate-item:not(.is-visible)'), 
							{
								autoAlpha: 1,
								scale: 1,
							},
							{
								autoAlpha: 1,
								scale: .8,
								stagger: {
									amount: 0.1,
									//from: 'start'
								},
								//duration: 4,
								overwrite: false,
								//ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									console.log('CAROUSEL ANIMATE OUT COMPLETE');
								})
							},
							
						);
						/**/
					});

					// Fired right before the carousel moves.
					primarySlider.on( 'move', function () {
						console.info('CAROUSEL MOVING');

						/** /
						const anim8Out = gsap.fromTo(
							document.body.querySelectorAll('.carousel-pirates .pirate-item'), 
							{
								autoAlpha: 1,
								scale: 1,
							},
							{
								autoAlpha: 0,
								scale: .8,
								stagger: {
									amount: 0.1,
									//from: 'start'
								},
								//duration: 4,
								overwrite: false,
								//ease: Power0.easeInOut
								//immediateRender: false,
								//ease: Power0.easeInOut
								ease: Power0.easeOut,
								onComplete: ((evt)=>{
									console.log('CAROUSEL ANIMATE OUT COMPLETE');
								})
							},
							
						);
						/**/
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'moved', function () {
						console.info('CAROUSEL MOVED');
					} );

					primarySlider.mount({ AutoScroll, Intersection });
					//primarySlider.mount(window.splide.Extensions);
					
					/**/
					slides.forEach((slide)=>{
						const pageTransition = document.body.querySelector('e-page-transition');
						slide.addEventListener('click',(evt)=>{
							const target =  evt.currentTarget;
							if( target ) {
								const customLink =  target.getAttribute('data-link');
								
								if( customLink ) {

									if( pageTransition ) {
										pageTransition.classList.remove('e-page-transition--entered');
										pageTransition.classList.add('e-page-transition--exiting');
									}

									const tt = setTimeout(()=>{
										window.location = customLink;
										clearTimeout(tt);
									}, 750);
									
								}
							}
							
						});
					});
					/**/
					
					
				});
			}

		}, false);

	});

})();
